import { NEUTRAL_600, NEUTRAL_1600, NEUTRAL_200, WHITE, OBSIDIAN } from 'visitor-ui-component-library/constants/WidgetColors';
import FileAttachmentTheme from '../../attachments/model/FileAttachmentTheme';
import QuickReplyTheme from '../../quick-reply/model/QuickReplyTheme';

/**
 * Represents the default values consumed by `PrimaryMessage` components required for rendering.
 */

export const defaultTheme = {
  alignItems: 'flex-start',
  avatarWidth: '32px',
  backgroundColor: NEUTRAL_200,
  borderColor: NEUTRAL_600,
  borderRadius: '4px',
  borderWidth: '1px',
  messageSpacing: '8px',
  textColor: NEUTRAL_1600,
  fileAttachmentTheme: FileAttachmentTheme(),
  quickReplyTheme: QuickReplyTheme(),
  widgetAccent: NEUTRAL_1600,
  headerBackgroundColor: WHITE,
  headerTextColor: OBSIDIAN,
  avatarBackgroundColor: NEUTRAL_600,
  avatarBorderColor: NEUTRAL_600,
  avatarTextColor: OBSIDIAN
};
const Theme = themeProps => Object.assign({}, defaultTheme, themeProps);
export default Theme;